import { render, staticRenderFns } from "./LogView.vue?vue&type=template&id=986cfaa4&scoped=true&"
import script from "./LogView.vue?vue&type=script&lang=js&"
export * from "./LogView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986cfaa4",
  null
  
)

export default component.exports